module.exports = __webpack_public_path__ + "static/media/bowling-pins.6abd4735.svg";